import { DropDownFilterModule } from "./widgets/dropdown-filter/dropdown-filter.component";
import { NgModule } from "@angular/core";
import {
	DxDrawerModule,
	DxToolbarModule,
	DxScrollViewModule,
	DxFormModule,
	DxButtonModule,
	DxLoadPanelModule,
	DxSelectBoxModule,
	DxCheckBoxModule,
	DxTextBoxModule,
	DxValidatorModule,
	DxValidationGroupModule,
	DxDropDownBoxModule,
	DxTreeViewModule,
	DxLoadIndicatorModule,
	DxTreeListModule,
	DxTemplateModule,
	DxNumberBoxModule,
	DxTagBoxModule,
	DxFunnelModule,
} from "devextreme-angular";
import { AutocompleteComponent, InfiniteScrollCustModule } from "./widgets";
import { ResizeObserverDirective } from "./directives/resize-observer.directive";
import { DropdownModule } from "./widgets/dropdown/dropdown.component";
import { DxoHatchingModule, DxoHoverStyleModule } from "devextreme-angular/ui/nested";

@NgModule({
	declarations: [ResizeObserverDirective],
	imports: [
		DxDrawerModule,
		DxToolbarModule,
		DxScrollViewModule,
		DxFormModule,
		DxButtonModule,
		DxLoadPanelModule,
		DxScrollViewModule,
		DxSelectBoxModule,
		AutocompleteComponent,
		DxCheckBoxModule,
		DxTextBoxModule,
		DxValidatorModule,
		DxValidationGroupModule,
		DropDownFilterModule,
		DxDropDownBoxModule,
		DxTreeViewModule,
		DxLoadIndicatorModule,
		DropdownModule,
		DxTreeListModule,
		DxTemplateModule,
		DxNumberBoxModule,
		DxTagBoxModule,
		InfiniteScrollCustModule,
		DxoHoverStyleModule,
		DxoHatchingModule,
		DxFunnelModule,
	],
	exports: [
		DxDrawerModule,
		DxToolbarModule,
		DxScrollViewModule,
		DxFormModule,
		DxButtonModule,
		DxLoadPanelModule,
		DxScrollViewModule,
		DxSelectBoxModule,
		AutocompleteComponent,
		DxCheckBoxModule,
		DxTextBoxModule,
		DxValidatorModule,
		DxValidationGroupModule,
		DropDownFilterModule,
		DxDropDownBoxModule,
		DxTreeViewModule,
		DxLoadIndicatorModule,
		ResizeObserverDirective,
		DropdownModule,
		DxTreeListModule,
		DxTemplateModule,
		DxNumberBoxModule,
		DxTagBoxModule,
		InfiniteScrollCustModule,
		DxoHoverStyleModule,
		DxoHatchingModule,
		DxFunnelModule,
	],
})
export class DevEpressCommonModule { }
